import { render, staticRenderFns } from "./Counseling.vue?vue&type=template&id=587d54aa&scoped=true"
import script from "./Counseling.vue?vue&type=script&lang=js"
export * from "./Counseling.vue?vue&type=script&lang=js"
import style0 from "./Counseling.vue?vue&type=style&index=0&id=587d54aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d54aa",
  null
  
)

export default component.exports